import styles from './SolutionFlat.module.scss';

import React, { FC, AllHTMLAttributes } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import type { SolutionPickerModule as SolutionPickerModuleType } from 'api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'components/Grid/Grid';
import { GridContainer } from 'components/GridContainer/GridContainer';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { SolutionFlatCard } from './SolutionFlatCard';
import { SolutionFlatTitle } from './SolutionFlatTitle';

interface ISolutionFlatProps extends AllHTMLAttributes<HTMLElement> {
  entry?: FlatEntry<SolutionPickerModuleType>;
}

export const SolutionFlat: FC<ISolutionFlatProps> = ({ entry }) => {
  if (!entry) return null;
  const { items = [] } = entry;

  const swiperProps = {
    speed: 500,
    loop: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 16,
  };

  return (
    <div className={styles.solutionPickerModuleSlider}>
      <GridContainer justifyContent="center">
        <Grid item xs={12}>
          <SolutionFlatTitle entry={entry} />
        </Grid>
      </GridContainer>
      <Grid container xs={12} className={styles.solutionPickerModuleContainer}>
        <Swiper {...swiperProps} className={styles.solutionPickerModuleProductSlider}>
          {items.map(item => (
            <SwiperSlide key={item.id} className={styles.swiperSlide}>
              <SolutionFlatCard item={item} key={item.title} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid>
    </div>
  );
};
SolutionFlat.displayName = 'SolutionFlat';
